<template>
  <div class="h-full pb-8 pt-0 w-full">
    <DataGetter
      @dataAvailable="
        data => {
          stats = data?.metaData
        }
      "
      :searchQuery="{ storeId: this.$route.params.storeId }"
      contentId="storeStats"
    />
    <div class="hidden">
      <div class="flex w-full border-b">
        <div
          class="flex gap-2 p-2 pb-4 relative justify-center cursor-pointer rounded-lg px-4"
          v-for="(tab, i) in tabs"
          :key="i"
          @click="activeTab = tab.id"
        >
          <div class="w-6 h-6">
            <img src="" alt="" class="w-full h-full" />
          </div>
          <div>{{ tab.name }}</div>
          <div
            :class="{
              'w-full bg-primary': activeTab == tab.id,
              'w-0 bg-transparent': activeTab !== tab.id,
            }"
            class="duration-300 absolute bottom-0 rounded-t-xl h-1"
          ></div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div>
      <DashboardTopBoxes
        :storeId="this.$route.params.storeId"
        :storeStats="stats"
      />
    </div>
    <div class="py-4"></div>
    <div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="relative md:col-span-2">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div
              class="flex gap-4 flex-col md:flex-row justify-between items-center"
            >
              <div class="title-color text-lg md:text-xl">
                Transactions & Commandes
              </div>
              <div class="flex gap-4">
                <button
                  v-for="(duration, i) in durations"
                  :key="i"
                  class="rounded-full border px-4 py-1 duration-300"
                  :class="{
                    'bg-primary-1000 text-white': activeDuration == duration.id,
                  }"
                  @click="activeDuration = duration.id"
                >
                  {{ duration.name }}
                </button>
              </div>
            </div>
            <div class="py-2"></div>
            <PlatformStat
              :storeStats="stats"
              :period="durations[activeDuration]"
            />
          </div>
        </div>
        <div class="relative col-span-1">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Paiements</div>
            </div>
            <div class="py-2"></div>
            <CirclePlatformStats :storeStats="stats" />
          </div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div v-if="false">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="relative md:col-span-2">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Derniers paiements</div>
            </div>
            <div class="py-2"></div>
            <LastPayments />
          </div>
        </div>
        <div class="relative md:col-span-1">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Derniers clients</div>
            </div>
            <div class="py-2"></div>
            <LastCustomers />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LastCustomers from '@/components/appData/LastCustomers.vue'
import LastPayments from '@/components/appData/LastPayments.vue'
import CirclePlatformStats from '@/components/stats/CirclePlatformStats.vue'
import DashboardTopBoxes from '@/components/store/DashboardTopBoxes.vue'
import PlatformStat from '@/components/stats/PlatformStat.vue'
import DataGetter from '../utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    PlatformStat,
    CirclePlatformStats,
    LastCustomers,
    LastPayments,
    DashboardTopBoxes,
  },
  data() {
    return {
      userData: {},
      eventsIds: [],
      stats: 'stats',
      tabs: [
        { name: 'Overview', id: 'overview' },
        { name: 'Medical Report', id: 'medicalReport' },
        { name: 'Patients Overview', id: 'tab3' },
        { name: 'Diagnose', id: 'tab4' },
      ],
      activeTab: 'home',
      durations: {
        paymentStatsYear: {
          name: '12 Mois',
          formatId: 'month',
          id: 'paymentStatsYear',
        },
        paymentStatsMonth: {
          name: '30 Jours',
          formatId: 'day',
          id: 'paymentStatsMonth',
        },
        paymentStatsWeek: {
          name: '14 Jours',
          formatId: 'day',
          id: 'paymentStatsWeek',
        },
        // { name: '1 Mois', id: '1month' },
      },
      activeDuration: 'paymentStatsYear',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {},
}
</script>
